<!--<p>url = {{url3_5}}</p><p>legacyWebUi - {{legacyWebUI}}</p><p>listSpec = {{listSpec}}</p>-->
@if (legacyWebUI && url3_5) {
  @if (unsupportedPattern && !isProduction) {
    <p
      style="font-weight: bold; color:red; height: 20px;text-align: center; position:absolute; width:100%">
      CURRENTLY UNSUPPORTED SOHO XI PATTERN DETECTED
    </p>
  }
  <lm-html-url-doc
    [url]="url3_5"
    [showLoading]="false"
  ></lm-html-url-doc>
}

@if (!url3_5) {
  <div class="scrollable-flex no-scroll lm-audit-log-list">
    <!-- Insert toolbar for compare button here! -->
    <lm-toolbar
      [maxVisibleButtons]="2"
      [hideToolbarTitles]="true"
      [buttons]="toolbarButtons"
      (appMenuTriggerEvent)="onAppMenuTriggerEvent($event)"
      (toolbarButtonEvent)="onToolbarButtonEvent($event)"
    ></lm-toolbar>
    <div soho-busyindicator
      class="main-audit-div"
      [blockUI]="true"
      [displayDelay]="20"
      [transparentOverlay]="true"
      >
      <div soho-datagrid
        data-automation-id="lm-audit-log-data-grid"
        [hidden]="!auditData"
        (selected)="onRowSelected($event)"
        [emptyMessage]="null"
      ></div>
    </div>
  </div>
}
